import React from 'react';

const UserAvatarIcon = ({
  size = 62,
  primaryColor = 'var(--primary-color, #256beb)',
  primaryContrastColor = 'var(--primary-contrast-color, #ffffff)',
  primaryBorderColor = 'var(--primary-color, #256beb)',
  className = '',
  style = {},
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 62.015884 62.015884"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
      focusable="false"
    >
      <circle
        cx="31.007942"
        cy="31.007942"
        r="30.611067"
        fill={primaryColor}
      />
      <path
        fill={primaryContrastColor}
        d="
          M31.0079 38.3706
          A17.6976 17.6976 0 0 0 13.3103 56.0687
          A30.6111 30.6111 0 0 0 31.0079 61.629
          A30.6111 30.6111 0 0 0 48.7056 56.0687
          A17.6976 17.6976 0 0 0 31.0079 38.3706
          Z
        "
      />
      <circle
        cx="31.0079"
        cy="20.5375"
        r="8.97984"
        fill={primaryContrastColor}
      />
      <circle
        cx="31.007942"
        cy="31.007942"
        r="30.611067"
        fill="none"
        stroke={primaryBorderColor}
        strokeWidth="0.79375"
      />
    </svg>
  );
};

export default UserAvatarIcon;
